module.exports = __webpack_public_path__ + "bff6eec4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram/Storytape-5.jpg
// module id = 1269
// module chunks = 1 4